import React from 'react'

import { RichIcon, RichIconProps } from '@ui/components/RichIcon/RichIcon'

import { Box } from '@shared/components/Box'

import styles from './ActionIcon.module.scss'

type Props = RichIconProps & {
  disabled?: boolean
} & (
    | {
        as?: 'div'
        'aria-label'?: string
        onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
      }
    | {
        as: 'button'
        'aria-label': string
        onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
      }
  )

export const ActionIcon: React.FC<Props> = (props) => {
  const { size = 'x20', as, disabled, onClick, 'aria-label': ariaLabel, ...restProps } = props

  if (as === 'button') {
    return (
      <button
        type='button'
        className={styles.icon}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={(event) => {
          if (!disabled) onClick?.(event)
        }}
      >
        <RichIcon size={size} {...restProps} />
      </button>
    )
  }

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!disabled && onClick) {
      onClick(event)
    }
  }

  return (
    <Box className={styles.icon} aria-label={ariaLabel} onClick={handleClick}>
      <RichIcon size={size} {...restProps} />
    </Box>
  )
}
